// extracted by mini-css-extract-plugin
export default {"toolbar":"AboutUniverseInfo_toolbar__lN5E0","containerBar":"AboutUniverseInfo_containerBar__SJc2L"};